import type { ResourceContainerResource as ResourceContainerResourceModel } from '@/adapters/catalogv1.g';

export function extractResourceContainerResource(
  model: ResourceContainerResourceModel
) {
  return {
    id: model._metadata?.distinct_id ?? '',
    containerRef: model.container_ref ?? '',
    resourceRef: model.resource_ref ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogResourceContainerResource = ReturnType<
  typeof extractResourceContainerResource
>;
